<template>
  <div v-if="show" class="swal2-container swal2-center swal2-backdrop-show" style="overflow-y: auto;" >
    <div aria-labelledby="swal2-title" aria-describedby="swal2-content" class="swal2-popup swal2-modal swal2-show" tabindex="-1" role="dialog" aria-live="assertive" aria-modal="true" style="display: flex;">
      <div class="swal2-header">
        <ul class="swal2-progress-steps" style="display: none;"></ul>
        <div class="swal2-icon swal2-error" style="display: none;"></div>
        <div class="swal2-icon swal2-question" style="display: none;"></div>
        <div class="swal2-icon swal2-warning" style="display: none;"></div>
        <div class="swal2-icon swal2-info" style="display: none;"></div>
        <div class="swal2-icon swal2-success" style="display: none;"></div>
        <h2 class="swal2-title" id="swal2-title" style="display: flex;">{{ data.title }}</h2>
        <button type="button" class="swal2-close" @click="close()" aria-label="Close this dialog" style="display: flex;">×</button>
      </div>
      <div class="swal2-content">
        <div id="swal2-content" class="swal2-html-container" style="display: block;">
          {{ data.body }}
        </div>
        <div class="swal2-validation-message" id="swal2-validation-message"></div>
      </div>
      <div class="swal2-actions">
        <button @click="suscribe()" type="button" class="swal2-confirm swal2-styled" aria-label="" style="display: inline-block; border-left-color: rgb(213, 32, 39); border-right-color: rgb(213, 32, 39);">
          {{ data.button }}</button>
        <button type="button" class="swal2-cancel swal2-styled" aria-label="" style="display: none;">Cancel</button>
      </div>
      <div class="swal2-footer" style="display: none;"></div>
      <div class="swal2-timer-progress-bar-container">
        <div class="swal2-timer-progress-bar" style="display: none;"></div>
      </div>
      <button class="swal2-close" @click="close()">×</button>
    </div>
  </div>
</template>

<script>
import '@/assets/css/sweetalert2.css';
export default {
  name: "alert",
  props: {
    data: {
      type: Object,
      default: function () {
        return {
          title: '',
          body: '',
          button: ''
        }
      }
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  methods:{
    close: function(){
      this.show = false;
      this.$parent.alertDataShow = false;
    },
    suscribe: function(){
      this.$parent.suscribe()
    }
  }

}
</script>

<style scoped>

</style>